"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var BrandedAppChangelogComponent = /*#__PURE__*/function () {
  BrandedAppChangelogComponent.$inject = ["appBrandingService"];
  /* @ngInject */
  function BrandedAppChangelogComponent(appBrandingService) {
    _classCallCheck(this, BrandedAppChangelogComponent);
    this.appBrandingService = appBrandingService;
  }
  _createClass(BrandedAppChangelogComponent, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      return this.appBrandingService.getChangelog(this.brandingId).then(function (_ref) {
        var data = _ref.data;
        return _this.changelog = _.map(data, _this.formatLog);
      }, function (err) {
        return console.error(err);
      });
    }
  }, {
    key: "formatLog",
    value: function formatLog(log) {
      log.icon = function () {
        switch (log.type) {
          case 'publishing-request-created':
            return 'icon-shop';
          case 'build-started':
            return 'icon-flash';
          case 'build-finished':
            return 'icon-check';
          case 'store-status':
            switch (log.status) {
              case 'in-review':
                return 'icon-hour-glass';
              case 'rejected':
                return 'icon-warning';
              case 'pending-release':
                return 'icon-thumbs-up';
              case 'published':
                return 'icon-check';
              default:
                return 'icon-shop';
            }
          default:
            return 'icon-new';
        }
      }();
      log.blurb = log.type;
      if (log.status) {
        log.blurb += ": ".concat(log.status);
      }
      if (log.type === 'created') {
        log.blurb += " by ".concat(log.fp_owner.split(':')[1]);
      }
      if (log.type === 'build-finished') {
        log.platform = function () {
          switch (log.platform) {
            case 'ios':
              return 'iOS';
            case 'android':
              return 'Android';
          }
        }();
        log.blurb += " of ".concat(log.build_type, " ").concat(log.platform, " app");
      }
      return _.pick(log, '_id', 'icon', 'blurb', 'created_at');
    }
  }]);
  return BrandedAppChangelogComponent;
}();
module.exports = angular.module('backstage.components.branded-app.branded-app-changelog', []).component('brandedAppChangelog', {
  templateUrl: '/src/angular/components/branded-app/branded-app-changelog/branded-app-changelog.html',
  bindings: {
    brandingId: '<'
  },
  controller: BrandedAppChangelogComponent
}).name;